import { getProductPricingConfig } from './product-pricing-configs';

import type { BillingCycle, Edition, ProductKey } from './types';

/**
 * Single source of truth for a product's billing cycle while the per-product
 * selector is hidden: monthly when supported, otherwise annual; always annual
 * for enterprise editions.
 */
export const resolveBillingCycle = (productKey: ProductKey, edition: Edition): BillingCycle => {
	if (edition === 'enterprise') return 'ANNUAL';
	return getProductPricingConfig(productKey).billingCycleConfig.monthly ? 'MONTHLY' : 'ANNUAL';
};
